import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import clientsData from "../../data/BrandsSlider/clients-brand.json";
import HeadingSection from "../HeadingSection/HeadingSection";
// import ContactForm from "../ContactUs/ContactForm"; // Використовується в закоментованому коді

const ClientsBrand = ({ children, classAppend }) => {
  const settings = {
    className: "clients-brand-carousel",
    slidesToShow: 6,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  return (
    <section style={{paddingTop:'0px'}} className="white-bg">
      <div className="container" id="section4">
        {children ? <div className="row">{children}</div> : null}
        <div className="row " >
          {
            <Slider {...settings}>
              {clientsData.map((client) => (
                <div className="client-logo" key={client.id} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <img
                    className="img-responsive"
                    src={require("../../assets/images/" + client.image)}
                    alt={client.name}
                  />
                </div>
              ))}
            </Slider>
          }
        </div>
      </div>
      {/* <div className="row">
        <HeadingSection tagline="Стати нашим партнером" >
          <ContactForm/>
        </HeadingSection>
      </div> */}
    </section>
  );
};

export default ClientsBrand;
